/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
// eslint-disable-next-line import/no-extraneous-dependencies
import * as React from 'react';
import classnames from 'classnames';
import OPButton from '../op-button';
// import event from '../event';
import { DialogSizeEnum, IconEnum } from './constants';
import './index.scss';
export default function Dialog(props) {
    let flagClass;
    const { className = '', visible = false, title, children, onOk = () => { }, onCancel = () => { }, footer = true, maskClosable = true, bodyStyle, size = 'small', okText = '确定', cancelText = '取消', icon, subTitle, footerActions = ['cancel', 'ok'], width, loading, okHotKey = 'Enter', cancelHotKey = 'Esc', cancelDisabled, okDisabled, state = '', } = props;
    const show = { opacity: 1 };
    const hide = { opacity: 0 };
    return visible ? (React.createElement("div", { className: classnames('op-dialog-container', state && `op-dialog-${state}`, className), style: visible ? show : hide },
        React.createElement("div", { className: 'op-dialog-inner-content', style: { width: width || DialogSizeEnum[size] } },
            React.createElement("div", { className: classnames('op-inner-content-header') },
                title && (React.createElement("div", { className: 'op-inner-content-title' },
                    icon && (React.createElement("img", { src: IconEnum[icon], width: '44', height: '44', style: { margin: '0 12px -6px 0 ' }, alt: '' })),
                    title)),
                subTitle && React.createElement("div", { className: 'op-dialog-sub-title' }, subTitle)),
            React.createElement("div", { className: classnames('op-inner-content-center'), style: bodyStyle }, children),
            footer && (React.createElement("div", { className: classnames('op-inner-content-footer') }, typeof footer === 'boolean' ? (React.createElement(React.Fragment, null, footerActions.map((item, index) => {
                if (index === 0) {
                    if (item === 'cancel') {
                        flagClass = 'cancel-left';
                    }
                    else {
                        flagClass = 'ok-left';
                    }
                }
                if (index === 1) {
                    if (item === 'cancel') {
                        flagClass = 'ok-left';
                    }
                    else {
                        flagClass = 'cancel-left';
                    }
                }
                return (React.createElement(React.Fragment, null,
                    item === 'cancel' && (React.createElement(OPButton, { "data-hottag": 'cn-op.dialog-cancel', disabled: cancelDisabled, type: 'secondary', key: item, onClick: onCancel, className: classnames({
                            'button-right': flagClass === 'cancel-left' &&
                                footerActions.length !== 1,
                        }), hotkey: cancelHotKey }, cancelText)),
                    item === 'ok' && (React.createElement(OPButton, { "data-hottag": 'cn-op.dialog-ok', disabled: okDisabled, loading: loading, key: item, type: 'primary', onClick: onOk, className: classnames({
                            'button-right': flagClass === 'ok-left' &&
                                footerActions.length !== 1,
                        }), hotkey: okHotKey }, okText))));
            }))) : (footer)))),
        React.createElement("div", { className: 'mask', onClick: () => maskClosable && onCancel() }))) : (React.createElement("div", null));
}
// export default OPDialog;
